import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  ProgramTypesGUID,
  EventCustomerValidationStatus,
  EventType
} from '../../../models/_enum-collections';
import { CustomerAckDocumentStatusRequest } from '../../../models/customer-ack-document-status-request.model';
import { CustomerAckRejectionReason } from '../../../models/customer-ack-rejection-reason.model';
import { CustomerAcknowledgementDocumentModel } from '../../../models/customer-acknowledgement-document.model';
import { CustomerAcknowledgementStatus } from '../../../models/customer-acknowledgement-status.model';
import { DocumentRawData } from '../../../models/document-raw-data.model';
import { EventDocumentRejectionReason } from '../../../models/event-document-rejection-reason.model';
import { EventPoeDocument } from '../../../models/event-poe-document.model';
import { EventPreviewDetails } from '../../../models/event-preview-details.model';
import { MrppPreviewInput } from '../../../models/event-preview-input.model';
import { EventRegistrationDocumentStatusRequest } from '../../../models/event-registration-document-status-request.model';
import { EventRegistrationDocumentModel } from '../../../models/event-registration-document.model';
import { EventRegistrationCustomerModel } from '../../../models/event-registration.model';
import { FileContentModel } from '../../../models/file-content.model';
import { ProgramSharedService } from '../../common/program-shared.service';
import { MrppRawDocumentDataConfig } from '../../mcap-events/preview/configs/event-preview-config';
import { EventDocumentStatus } from '../../../models/event-document-status.model';
import { UpdateEventDocumentsStatusRequest } from '../../../models/update-event-documents-status-request.model';
import { UpdateCustomerAckDocumentsStatusRequest } from '../../../models/update-customer-ack-document-status-request.model';
import { CommonSharedModule } from '../../common/shared.module';
import { PreviewContentComponent } from '../../shared/preview-content/preview-content.component';
import { PreviewConfirmationFormComponent } from '../../shared/preview-confirmation-form/preview-confirmation-form.component';
import { EventEditService } from '../../services/event-edit.service';
import programConfigJson from '../mrpp-preview/mrpp-preview-config.json';

@Component({
  selector: 'app-mrpp-preview',
  templateUrl: './mrpp-preview.component.html',
  styleUrls: ['./mrpp-preview.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    PreviewContentComponent,
    PreviewConfirmationFormComponent
  ]
})
export class MrppPreviewComponent implements OnInit {
  eventRawData!: DocumentRawData[];
  eventPreviewData!: EventPoeDocument;
  eventPreviewType!: string;
  eventDocumentTypeId!: number;
  eventRegistrationDocumentId!: number;
  @Input() mrppPreviewInput!: MrppPreviewInput;
  @Output() closePreviewModal = new EventEmitter<boolean>();
  @Output() reLoadList: EventEmitter<any> = new EventEmitter<any>();
  @Input() programTypeGUID!: string;
  fileContentModel!: FileContentModel;
  isDocumentPreviewLoading = false;
  canShowMrppPreviewModel!: boolean;
  eventId!: number;
  downloadSpin = true;
  index = 0;
  isEngDtl = false;
  isCustomerAck = false;
  eventIdList!: number[];
  eventIndex!: number;
  showApproveDeny!: boolean;
  msgsUsageDetails!: any[];
  modalTitle!: string;
  invoiceRejectionList!: EventDocumentRejectionReason[];
  customerAckRejectionList!: CustomerAckRejectionReason[];
  rejectionList: any;
  invoiceRejectionModalDisplay!: boolean;
  datePipe = new DatePipe('en-US');
  invoiceDocumentType = 'POEInvoice';
  rollCallDocumentType = 'DealAssociationTemplateRFP';
  skuPurchaseTrialDocumentType = 'CustomerAwardLetter';
  savedPoeDocumentType = 'savedPoe';
  dealAssociationCPORTemplateType = 'CustomerPartnerOfRecord';
  dealAssociationPoeTemplateType = 'DealAssociationTemplate';
  madScreenshotType = 'MADPOE';
  findingsTemplateType = 'FindingsTemplate';
  publicSectorTemplateType = 'PublicSectorPOE';
  microsoftInvoiceTemplateType = 'MicrosoftInvoiceTemplate';
  customerAckApproval = 'CustomerAcknowledgement';
  sowPreviewType = 'SOW';
  documentUploadedDate!: Date;
  documentStatus!: string;
  surveyDate!: string;
  surveyStatus!: string;
  poeDetailsForm!: FormGroup;
  approvedCustomersList: string[] = [];
  showTypeChangeButtons!: boolean;
  selectedWorkshopCompletionDate!: Date;
  eventDocuments!: EventRegistrationDocumentModel;
  customerAckDocument!: CustomerAcknowledgementDocumentModel;
  eventDocumentStatuses!: EventDocumentStatus[];
  customerAcknowledgementDocumentStatuses!: CustomerAcknowledgementStatus[];
  showApproveRejectLoadder!: boolean;
  hideNextPrevious!: boolean;
  isApproveReject!: boolean;
  hasCustomerAcknowledgement!: boolean;
  isOnetoMany!: boolean;
  eventCustomers!: {
    eventId: number;
    eventCustomers: EventRegistrationCustomerModel[];
  }[];
  eventTypeId!: number;
  hasPreviewDataLoaded = false;
  disableAcceptRejectButtons!: boolean;
  fileName!: string;
  programConfig = programConfigJson;

  constructor(
    private eventEditService: EventEditService,
    private programSharedService: ProgramSharedService
  ) {}

  ngOnInit() {
    this.programTypeGUID = ProgramTypesGUID.MRPP;
    this.hideNextPrevious = this.mrppPreviewInput.hideNextPrevious || false;
    this.canShowMrppPreviewModel = true;
    this.eventId = this.mrppPreviewInput.eventId;
    this.eventIdList = this.mrppPreviewInput.eventIdList || [];
    this.eventTypeId = this.mrppPreviewInput.eventTypeId || -1;
    this.eventIndex = this.eventIdList.indexOf(this.mrppPreviewInput.eventId);
    this.showPreview(this.mrppPreviewInput.eventId);
    this.getEventDocumentStatuses();
    this.getCustomerAcknowledgementStatuses();
    this.programSharedService.setEventType(this.eventTypeId);
    this.eventCustomers = this.mrppPreviewInput.eventCustomers || [];
    this.isOnetoMany = this.mrppPreviewInput.isOneToMany;
    this.fileName = this.mrppPreviewInput.fileName || '';
    this.approvedCustomersList =
      this.eventCustomers &&
      this.eventCustomers != undefined &&
      this.eventCustomers.find(x => x.eventId == this.eventId)
        ? this.eventCustomers
            .find(x => x.eventId == this.eventId)
            ?.eventCustomers.filter(
              cus =>
                cus.eventCustomerValidationStatusId ==
                EventCustomerValidationStatus.Approved
            )
            .map(cus => cus.customerName) || []
        : [];

    this.eventPreviewType = this.preiviewType;
  }

  get preiviewType() {
    if (this.mrppPreviewInput.isPoeInvoicePreview)
      return this.invoiceDocumentType;
    else if (this.mrppPreviewInput.isRollCallPreview)
      return this.rollCallDocumentType;
    else if (this.mrppPreviewInput.isSKUPurchaseTrialPreview)
      return this.skuPurchaseTrialDocumentType;
    else if (this.mrppPreviewInput.isDealAssociationCPORTemplate)
      return this.dealAssociationCPORTemplateType;
    else if (this.mrppPreviewInput.isDealAssociationPoeTemplate)
      return this.dealAssociationPoeTemplateType;
    else if (this.mrppPreviewInput.isMADScreenshot)
      return this.madScreenshotType;
    else if (this.mrppPreviewInput.isPublicSectorTemplate)
      return this.publicSectorTemplateType;
    else if (this.mrppPreviewInput.isMicrosoftInvoiceTemplate)
      return this.microsoftInvoiceTemplateType;
    else if (this.mrppPreviewInput.isCustomerAckApproval)
      return this.customerAckApproval;
    else if (this.mrppPreviewInput.isPOETemplatePreview)
      return this.findingsTemplateType;
    else if (this.mrppPreviewInput.isSOWPreview) return this.sowPreviewType;
    else if (this.mrppPreviewInput.isSavedDocumentPreview)
      return this.savedPoeDocumentType;
    return '';
  }

  get previewTitle() {
    switch (this.preiviewType) {
      case this.skuPurchaseTrialDocumentType:
        return 'RFP Award Letter Preview';
      case this.dealAssociationCPORTemplateType:
        return 'Deal Association CPOR Preview';
      case this.dealAssociationPoeTemplateType:
        return 'Deal Association POE Preview';
      case this.rollCallDocumentType:
        return 'Deal Association RFP Preview ';
      case this.invoiceDocumentType:
        return 'Workshop Invoice POE Template Preview';
      case this.madScreenshotType:
        return 'MAD Screenshot Preview';
      case this.publicSectorTemplateType:
        return 'Public Sector Template Preview';
      case this.microsoftInvoiceTemplateType:
        return 'Microsoft Invoice Template Preview';
      case this.customerAckApproval:
        return 'Customer Acknowledgement Preview';
      case this.findingsTemplateType:
        return 'POE Document Preview';
      case this.sowPreviewType:
        return 'Statement of Work Preview';
      default:
        return 'Deal Association Document Preview';
    }
  }

  get rejectButtonDisabled() {
    return (
      this.disableAcceptRejectButtons &&
      this.preiviewType == this.invoiceDocumentType
    );
  }

  get acceptButtonDisabled() {
    return (
      this.disableAcceptRejectButtons &&
      this.preiviewType == this.invoiceDocumentType
    );
  }

  get showApproveButton() {
    return (
      this.showApproveDeny && this.preiviewType != this.savedPoeDocumentType
    );
  }

  get showRejectButton() {
    return (
      this.showApproveDeny && this.preiviewType != this.savedPoeDocumentType
    );
  }

  public readonly hasAdditionalNotesSection = true;

  showPreview(eventId) {
    this.canShowMrppPreviewModel = true;
    this.index =
      this.mrppPreviewInput.eventId === eventId
        ? this.mrppPreviewInput.previewFileIndex
        : 0;
    this.showApproveDeny = true;
    this.eventRawData = [];
    this.showApproveRejectLoadder = false;
    this.eventId = eventId;
    this.getEventDetails(eventId);
  }

  closePreview() {
    this.canShowMrppPreviewModel = false;

    if (!this.showApproveDeny) {
      this.reLoadList.emit(true);
    }

    this.closePreviewModal.emit(false);
  }

  checkForPrevious() {
    return !(this.eventIndex == 0);
  }
  checkForNext() {
    return !(this.eventIndex == this.eventIdList.length - 1);
  }

  onPreviousClick() {
    const eventId = this.eventIdList[--this.eventIndex];
    this.eventId = eventId;
    this.approvedCustomersList =
      (this.mrppPreviewInput.eventCustomers &&
        this.mrppPreviewInput.eventCustomers.find(
          x => x.eventId == this.eventId
        ) &&
        this.mrppPreviewInput.eventCustomers
          .find(x => x.eventId == this.eventId)
          ?.eventCustomers.filter(
            cus =>
              cus.eventCustomerValidationStatusId ==
              EventCustomerValidationStatus.Approved
          )
          .map(cus => cus.customerName)) ||
      [];
    this.showPreview(eventId);
  }

  onNextClick() {
    const eventId = this.eventIdList[++this.eventIndex];
    this.eventId = eventId;
    this.showPreview(eventId);
    this.approvedCustomersList =
      (this.mrppPreviewInput.eventCustomers &&
        this.mrppPreviewInput.eventCustomers.find(
          x => x.eventId == this.eventId
        ) &&
        this.mrppPreviewInput.eventCustomers
          .find(x => x.eventId == this.eventId)
          ?.eventCustomers.filter(
            cus =>
              cus.eventCustomerValidationStatusId ==
              EventCustomerValidationStatus.Approved
          )
          .map(cus => cus.customerName)) ||
      [];
  }

  onDenyOpen() {
    this.invoiceRejectionModalDisplay = true;
    if (this.mrppPreviewInput.isCustomerAckApproval) {
      this.getCustomerAckRejectionReasonList();
    } else {
      this.getInvoiceRejectionReasonList();
    }
  }

  getEventDocumentStatuses() {
    this.eventEditService.getEventDocumentStatuses().subscribe(result => {
      this.eventDocumentStatuses = result;
    });
  }

  getCustomerAcknowledgementStatuses() {
    this.eventEditService
      .getCustomerAcknowledgementStatuses()
      .subscribe(result => {
        this.customerAcknowledgementDocumentStatuses = result;
      });
  }

  getInvoiceRejectionReasonList() {
    this.eventEditService
      .getEventDocumentRejectionReasons()
      .subscribe(result => {
        this.rejectionList = result.filter(
          x => x.eventDocumentTypeId === this.eventDocumentTypeId
        );
      });
  }

  getCustomerAckRejectionReasonList() {
    this.eventEditService
      .getCustomerAckRejectionReasonList()
      .subscribe(result => {
        this.rejectionList = result;
      });
  }

  getEventDetails(eventId): void {
    this.hasPreviewDataLoaded = false;
    this.eventPreviewData = new EventPoeDocument();
    this.eventPreviewData.eventId = eventId;
    this.eventDocumentTypeId = NaN;

    if (!this.mrppPreviewInput.isCustomerAckApproval) {
      this.eventEditService.getEventDocuments(eventId).subscribe(result => {
        this.eventDocuments = result;
        let doc;
        if (this.preiviewType != this.savedPoeDocumentType) {
          if (this.mrppPreviewInput.isSavedDocumentPreview) {
            doc = this.eventDocuments.documentHistories.find(
              x => x.fileName === this.mrppPreviewInput.fileName
            );
          } else {
            doc = this.eventDocuments.documents.find(
              x => x.documentType === this.preiviewType
            );
          }
          this.documentStatus = doc.documentStatus;
          this.documentUploadedDate = doc.uploadDate;
          this.eventPreviewData.fileName = this.fileName
            ? this.fileName
            : doc.fileName;
          this.eventPreviewData.documentType = 'POEInvoice';
          this.eventDocumentTypeId = doc.eventDocumentTypeId;
          this.eventRegistrationDocumentId = doc.eventRegistrationDocumentId;
        }
        this.eventEditService
          .getEventDocumentPreviewDetails(
            eventId,
            doc.eventRegistrationDocumentId
          )
          .subscribe(details => {
            this.hasCustomerAcknowledgement =
              details.hasCustomerAcknowledgement;
            this.eventRawData = this.getRawDataBinded(details);
            this.hasPreviewDataLoaded = true;
            this.disableAcceptRejectButtons = details.disableButton || false;
          });
      });
    } else {
      if (this.mrppPreviewInput.isCustomerAckApproval) {
        this.eventEditService
          .getCustomerAcknowledgementDocument(eventId)
          .subscribe(result => {
            this.customerAckDocument = result;
            let doc;
            if (this.preiviewType != this.savedPoeDocumentType) {
              doc = this.customerAckDocument.documents;
              this.documentStatus = doc[0].documentStatus;
              this.documentUploadedDate = doc[0].uploadDate;
              this.eventPreviewData.fileName = doc[0].fileName;
              this.eventPreviewData.documentType = 'CustomerAcknowledgement';
            }
            this.eventEditService
              .getCustomerAckDocumentPreviewDetails(eventId)
              .subscribe(details => {
                this.hasCustomerAcknowledgement =
                  details.hasCustomerAcknowledgement;
                this.eventRawData = this.getRawDataBinded(details);
                this.hasPreviewDataLoaded = true;
                this.disableAcceptRejectButtons =
                  details.disableButton || false;
              });
          });
      }
    }
  }
  getRawDataBinded(
    eventPreviewDetails: EventPreviewDetails
  ): DocumentRawData[] {
    console.clear();
    return MrppRawDocumentDataConfig.map(con => {
      const dr: any = {};
      switch (con.key) {
        case 'poeExpirationDate': {
          let workshopConfig = this.programConfig.program
            .find(p => p.programTypeGuid == this.programTypeGUID)
            ?.page.workshop.find(
              w => w.workshopTypeId == this.programSharedService.getEventType()
            );
          if (!workshopConfig) {
            workshopConfig = this.programConfig.program
              .find(p => p.programTypeGuid == this.programTypeGUID)
              ?.page.workshop.find(w => w.workshopTypeId == null);
          }
          if (workshopConfig) {
            dr.value = this.addDays(
              new Date(
                workshopConfig.workshopTypeId ==
                  EventType.TeamsRoomsOneToMany ||
                workshopConfig.workshopTypeId == EventType.TeamsRoomsPilot
                  ? eventPreviewDetails.committedDate
                  : eventPreviewDetails.registrationDate
              ),
              workshopConfig.model.poeExpiryDays
            );
          }
          break;
        }
        case 'documentStatus': {
          dr.value = this.documentStatus;
          break;
        }
        case 'customerAckExpirationDate': {
          dr.isHidden = !this.hasCustomerAcknowledgement;
          dr.value = this.addDays(
            new Date(eventPreviewDetails.registrationDate),
            30
          );
          break;
        }
        case 'approvedCustomersList': {
          dr.isHidden = !this.approvedCustomersList.length;
          dr.value = this.approvedCustomersList;
          break;
        }
        default: {
          dr.value = eventPreviewDetails[con.key];
        }
      }
      dr.label = con.label;
      dr.type = con.type;
      return dr;
    });
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }
  submitForApproval() {
    this.isApproveReject = true;
    this.showApproveRejectLoadder = true;
    if (!this.mrppPreviewInput.isCustomerAckApproval) {
      const eventRegistrationDocumentStatusRequests: EventRegistrationDocumentStatusRequest[] =
        [];

      const request: EventRegistrationDocumentStatusRequest = {
        eventRegistrationDocumentId: this.eventRegistrationDocumentId,
        eventDocumentStatusId:
          this.eventDocumentStatuses.find(x => x.name === 'Completed')
            ?.eventDocumentStatusId || -1,
        eventDocumentRejectionReasonIds: []
      };

      eventRegistrationDocumentStatusRequests.push(request);

      const updateRequest: UpdateEventDocumentsStatusRequest = {
        eventRegistrationDocumentStatusRequests:
          eventRegistrationDocumentStatusRequests,
        additionalRejectionReason: ''
      };

      this.eventEditService.updateEventDocumentsStatus(updateRequest).subscribe(
        () => {
          this.showApproveRejectLoadder = false;
          this.showApproveDeny = false;
          this.documentStatus = 'Completed';
          this.showMessage(this.aprrovedMessage);
          this.isApproveReject = false;
        },
        error => {
          this.showApproveRejectLoadder = false;
          this.showMessage(error.error.errorInfo, true);
          this.isApproveReject = false;
        }
      );
    } else {
      let customerAckDocumentStatusRequests: CustomerAckDocumentStatusRequest =
        {
          eventRegistrationId: 0,
          customerAcknowledgementStatusId: 0,
          customerAckRejectionReasonIds: []
        };

      const request: CustomerAckDocumentStatusRequest = {
        eventRegistrationId: this.eventId,
        customerAcknowledgementStatusId:
          this.customerAcknowledgementDocumentStatuses.find(
            x => x.name === 'Approved'
          )?.customerAcknowledgementStatusId || -1,
        customerAckRejectionReasonIds: []
      };

      customerAckDocumentStatusRequests = request;

      const updateRequest: UpdateCustomerAckDocumentsStatusRequest = {
        updateCustomerAckDocumentStatusRequests:
          customerAckDocumentStatusRequests,
        additionalRejectionReason: ''
      };

      this.eventEditService
        .updateCustomerAckDocumentsStatus(updateRequest)
        .subscribe(
          () => {
            this.showApproveRejectLoadder = false;
            this.showApproveDeny = false;
            this.documentStatus = 'Completed';
            this.showMessage(this.aprrovedMessage);
            this.isApproveReject = false;
          },
          error => {
            this.showApproveRejectLoadder = false;
            this.showMessage(error.error.errorInfo, true);
            this.isApproveReject = false;
          }
        );
    }
  }

  rejectDocument(reason) {
    this.isApproveReject = true;
    if (!this.mrppPreviewInput.isCustomerAckApproval) {
      const eventRegistrationDocumentStatusRequests: EventRegistrationDocumentStatusRequest[] =
        [];

      const request: EventRegistrationDocumentStatusRequest = {
        eventRegistrationDocumentId: this.eventRegistrationDocumentId,
        eventDocumentStatusId:
          this.eventDocumentStatuses.find(x => x.name === 'Rejected')
            ?.eventDocumentStatusId || -1,
        eventDocumentRejectionReasonIds: []
      };

      if (reason.selectedReasons) {
        reason.selectedReasons.forEach(element => {
          request.eventDocumentRejectionReasonIds.push(
            element.eventDocumentRejectionReasonId
          );
        });
      }

      eventRegistrationDocumentStatusRequests.push(request);

      const updateEventDocumentsStatusRequest: UpdateEventDocumentsStatusRequest =
        {
          eventRegistrationDocumentStatusRequests:
            eventRegistrationDocumentStatusRequests,
          additionalRejectionReason: reason.additionalNotes
        };

      this.eventEditService
        .updateEventDocumentsStatus(updateEventDocumentsStatusRequest)
        .subscribe(
          () => {
            this.showApproveDeny = false;
            this.documentStatus = 'Rejected';
            this.showMessage(this.rejectedMessage);
            this.isApproveReject = false;
          },
          error => {
            this.showMessage(error.error.errorInfo, true);
            this.isApproveReject = false;
          }
        );
    } else {
      let customerAckDocumentStatusRequests: CustomerAckDocumentStatusRequest =
        {
          eventRegistrationId: 0,
          customerAcknowledgementStatusId: 0,
          customerAckRejectionReasonIds: []
        };

      const request: CustomerAckDocumentStatusRequest = {
        eventRegistrationId: this.eventId,
        customerAcknowledgementStatusId:
          this.customerAcknowledgementDocumentStatuses.find(
            x => x.name === 'Rejected'
          )?.customerAcknowledgementStatusId || -1,
        customerAckRejectionReasonIds: []
      };

      if (reason.selectedReasons) {
        reason.selectedReasons.forEach(element => {
          request.customerAckRejectionReasonIds.push(
            element.customerAcknowledgementRejectionReasonId
          );
        });
      }

      customerAckDocumentStatusRequests = request;

      const updateRequest: UpdateCustomerAckDocumentsStatusRequest = {
        updateCustomerAckDocumentStatusRequests:
          customerAckDocumentStatusRequests,
        additionalRejectionReason: ''
      };

      this.eventEditService
        .updateCustomerAckDocumentsStatus(updateRequest)
        .subscribe(
          () => {
            this.showApproveDeny = false;
            this.documentStatus = 'Rejected';
            this.showMessage(this.rejectedMessage);
            this.isApproveReject = false;
          },
          error => {
            this.showMessage(error.error.errorInfo, true);
            this.isApproveReject = false;
          }
        );
    }
    this.closeDeclineModal();
  }

  closeDeclineModal() {
    this.invoiceRejectionModalDisplay = false;
  }

  get rejectedMessage() {
    switch (this.preiviewType) {
      case this.skuPurchaseTrialDocumentType:
        return 'RFP Award Letter document rejected.';
      case this.dealAssociationCPORTemplateType:
        return 'Deal Association CPOR document rejected.';
      case this.dealAssociationPoeTemplateType:
        return 'Deal Association POE document rejected';
      case this.rollCallDocumentType:
        return 'Deal Association RFP document rejected.';
      case this.invoiceDocumentType:
        return 'Workshop Invoice POE Document rejected.';
      case this.madScreenshotType:
        return 'MAD Screenshot rejected.';
      case this.publicSectorTemplateType:
        return 'Public Sector document rejected.';
      case this.microsoftInvoiceTemplateType:
        return 'Microsoft Invoice document rejected.';
      case this.customerAckApproval:
        return 'Customer Acknowledgement document rejected.';
      case this.findingsTemplateType:
        return 'POE document rejected.';
      case this.sowPreviewType:
        return 'Statement of Work document rejected';
      default:
        return '';
    }
  }

  get aprrovedMessage() {
    switch (this.preiviewType) {
      case this.skuPurchaseTrialDocumentType:
        return 'RFP Award Letter document approved.';
      case this.dealAssociationCPORTemplateType:
        return 'Deal Association CPOR document approved.';
      case this.dealAssociationPoeTemplateType:
        return 'Deal Association POE document approved';
      case this.rollCallDocumentType:
        return 'Deal Association RFP document approved.';
      case this.invoiceDocumentType:
        return 'Workshop Invoice POE Document approved.';
      case this.madScreenshotType:
        return 'MAD Screenshot approved.';
      case this.publicSectorTemplateType:
        return 'Public Sector document approved.';
      case this.microsoftInvoiceTemplateType:
        return 'Microsoft Invoice document approved.';
      case this.customerAckApproval:
        return 'Customer Acknowledgement document approved.';
      case this.findingsTemplateType:
        return 'POE document approved.';
      case this.sowPreviewType:
        return 'Statement of Work document approved';
      default:
        return '';
    }
  }

  showMessage(message: string, isError?: boolean) {
    this.msgsUsageDetails = [];
    this.msgsUsageDetails.push({
      severity: !isError ? 'success' : 'error',
      detail: message
    });
  }

  confirmClick(data) {
    this.rejectDocument(data);
  }
}
